const BIOMASS_FORMS = ['Chip', 'Round Wood', 'Bales'] as const;

export type BiomassForm = typeof BIOMASS_FORMS[number];

export type StorageCrop = {
  name: string;
  materialForm: BiomassForm;
  driedYield: number;
  bulkDensity: number;
  vehicle: string;
  weight: number;
  ash: number; // In %
};

export type StorageCropId = keyof typeof STORAGE_CROPS;

export const STORAGE_CROPS: {[id: string]: StorageCrop} = {
  srcFresh: {
    name: 'SRC Willow & Poplar (freshly harvested)',
    materialForm: 'Chip',
    driedYield: 8,
    bulkDensity: 0.263,
    vehicle: '100 cu m walking floor',
    weight: 26,
    ash: 4,
  },
  srcSeasoned: {
    name: 'SRC Willow & Poplar (seasoned)',
    materialForm: 'Chip',
    driedYield: 8,
    bulkDensity: 0.2,
    vehicle: '34 cu m tipper truck',
    weight: 6.8,
    ash: 2,
  },
  srfPoplar: {
    name: 'SRF Poplar',
    materialForm: 'Round Wood',
    driedYield: 10,
    bulkDensity: 0.7,
    vehicle: 'Dedicated timber artic',
    weight: 20,
    ash: 1,
  },
  srfEucalyptus: {
    name: 'SRF Eucalyptus',
    materialForm: 'Round Wood',
    driedYield: 10,
    bulkDensity: 0.7,
    vehicle: 'Dedicated timber artic',
    weight: 25,
    ash: 0.5,
  },
  miscanthusChip: {
    name: 'Miscanthus Chip',
    materialForm: 'Chip',
    driedYield: 9.2,
    bulkDensity: 0.1,
    vehicle: 'Tractor & Trailer',
    weight: 2,
    ash: 4,
  },
  miscanthusBale: {
    name: 'Miscanthus Bale',
    materialForm: 'Bales',
    driedYield: 9.2,
    bulkDensity: 0.14,
    vehicle: 'Flat bed lorry & drag',
    weight: 22,
    ash: 4,
  },
  reedCanaryGrass: {
    name: 'Reed Canary Grass',
    materialForm: 'Bales',
    driedYield: 4.3,
    bulkDensity: 0.14,
    vehicle: 'Tractor & Trailer',
    weight: 5,
    ash: 6.5,
  },
} as const;
